import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex flex-column align-items-center justify-content-center pt-3 pb-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3 border-solid border-1 surface-border" }, null, -1)
const _hoisted_3 = { class: "field flex justify-content-center" }
const _hoisted_4 = { class: "field flex justify-content-center" }
const _hoisted_5 = { class: "flex flex-wrap" }
const _hoisted_6 = { class: "w-12 md:w-6 lg:w-6 p-1" }
const _hoisted_7 = { class: "grid ml-0 mr-0" }
const _hoisted_8 = { class: "col-2 pl-0 pr-1 pb-0" }
const _hoisted_9 = { class: "field mb-1" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "mb-1",
  for: "multipackage-code"
}, "Kód", -1)
const _hoisted_11 = { class: "col-4 pl-0 pr-1 pb-0" }
const _hoisted_12 = { class: "field mb-1" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "mb-1",
  for: "package-location"
}, "Umiestnenie", -1)
const _hoisted_14 = { class: "col-6 pl-0 pr-0 pb-0" }
const _hoisted_15 = { class: "field mb-1" }
const _hoisted_16 = {
  class: "flex align-items-center justify-content-between",
  style: {"margin-bottom":"0rem"}
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "mb-1" }, "Farba", -1)
const _hoisted_18 = { class: "flex align-items-center justify-content-right" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  for: "imitation",
  class: "mr-2 mb-1"
}, "Imit. dreva", -1)
const _hoisted_20 = {
  key: 0,
  class: "flex align-items-center"
}
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "flex align-items-center" }
const _hoisted_23 = { class: "w-12 md:w-6 lg:w-6 p-1" }
const _hoisted_24 = { class: "grid ml-0 mr-0" }
const _hoisted_25 = { class: "col-4 pl-0 pr-1 pb-0" }
const _hoisted_26 = { class: "field mb-1" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", {
  class: "mb-1",
  for: "multipack-numberOfPieces"
}, "Počet kusov", -1)
const _hoisted_28 = { class: "col-4 pl-1 pr-1 pb-0" }
const _hoisted_29 = { class: "field mb-1" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", {
  class: "mb-1",
  for: "multipack-numberOfFreePieces"
}, "Voľné kusy", -1)
const _hoisted_31 = { class: "col-4 pl-1 pr-0 pb-0" }
const _hoisted_32 = { class: "field mb-1" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", {
  class: "mb-1",
  for: "multipack-numberOfReservedPieces"
}, "Rezerv. kusy", -1)
const _hoisted_34 = { class: "w-12 md:w-6 lg:w-6 p-1" }
const _hoisted_35 = { class: "grid ml-0 mr-0" }
const _hoisted_36 = { class: "col-10 pl-0 pr-1 pb-0" }
const _hoisted_37 = { class: "field mb-2" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", {
  class: "mb-1",
  for: "package-category"
}, "Kategória", -1)
const _hoisted_39 = {
  key: 0,
  class: ""
}
const _hoisted_40 = { class: "text-sm" }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { class: "text-sm" }
const _hoisted_43 = { class: "" }
const _hoisted_44 = { class: "col-2 pr-0 pl-0 pb-0" }
const _hoisted_45 = { class: "field mb-1" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", {
  class: "mb-1",
  for: "product-number"
}, "Počet", -1)
const _hoisted_47 = { class: "grid ml-0 mr-0" }
const _hoisted_48 = { class: "col-10 pl-0 pr-1 pb-0" }
const _hoisted_49 = { class: "field mb-1" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", {
  class: "mb-1",
  for: "package-product"
}, "Produkt", -1)
const _hoisted_51 = { class: "flex align-items-center justify-content-between" }
const _hoisted_52 = {
  key: 0,
  class: ""
}
const _hoisted_53 = { class: "text-sm" }
const _hoisted_54 = { key: 1 }
const _hoisted_55 = { class: "text-sm" }
const _hoisted_56 = { class: "text-sm" }
const _hoisted_57 = { class: "col-2 pr-0 pl-0 pb-0" }
const _hoisted_58 = { class: "field mb-1" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", {
  class: "mb-1",
  for: "package-length"
}, "Dĺžka", -1)
const _hoisted_60 = { class: "flex justify-content-center mb-1" }
const _hoisted_61 = {
  key: 0,
  class: "image-container"
}
const _hoisted_62 = ["src"]
const _hoisted_63 = {
  key: 1,
  class: "image-container placeholder"
}
const _hoisted_64 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-image placeholder-icon" }, null, -1)
const _hoisted_65 = [
  _hoisted_64
]
const _hoisted_66 = { class: "field flex justify-content-center" }
const _hoisted_67 = { class: "grid ml-0 mr-0" }
const _hoisted_68 = { class: "col-10 pl-0 pr-1 pb-0" }
const _hoisted_69 = { class: "field mb-1" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("label", {
  class: "mb-1",
  for: "package-product"
}, "Názov", -1)
const _hoisted_71 = { class: "col-2 pr-0 pl-0 pb-0" }
const _hoisted_72 = { class: "field mb-1" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("label", {
  class: "mb-1",
  for: "package-length"
}, "Dĺžka", -1)
const _hoisted_74 = { class: "grid ml-0 mr-0" }
const _hoisted_75 = { class: "col-8 pl-0 pr-1 pb-0" }
const _hoisted_76 = { class: "mini-image-container mr-1" }
const _hoisted_77 = ["src", "onLoad"]
const _hoisted_78 = { class: "col-4 pl-0 pr-0 pb-0" }
const _hoisted_79 = { class: "field mb-1" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("label", {
  class: "mb-1",
  for: "package-numberOfPieces"
}, "Počet kusov", -1)
const _hoisted_81 = { class: "field mb-1" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("label", {
  class: "mb-1",
  for: "package-numberOfFreePieces"
}, "Voľné kusy", -1)
const _hoisted_83 = { class: "field mb-1" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("label", {
  class: "mb-1",
  for: "package-numberOfReservedPieces"
}, "Rezerv. kusy", -1)
const _hoisted_85 = {
  key: 0,
  class: "text-sm font-italic text-red-400"
}
const _hoisted_86 = { class: "field mt-1" }
const _hoisted_87 = {
  class: "flex align-items-center justify-content-between",
  style: {}
}
const _hoisted_88 = {
  class: "w-8 pr-1",
  style: {"position":"relative"}
}
const _hoisted_89 = { key: 0 }
const _hoisted_90 = { key: 1 }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("span", {
  class: "flex justify-content-center align-items-center",
  style: {"width":"1.8rem"}
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: "p-icon p-button-icon"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M7.01744 10.398C6.91269 10.3985 6.8089 10.378 6.71215 10.3379C6.61541 10.2977 6.52766 10.2386 6.45405 10.1641L1.13907 4.84913C1.03306 4.69404 0.985221 4.5065 1.00399 4.31958C1.02276 4.13266 1.10693 3.95838 1.24166 3.82747C1.37639 3.69655 1.55301 3.61742 1.74039 3.60402C1.92777 3.59062 2.11386 3.64382 2.26584 3.75424L7.01744 8.47394L11.769 3.75424C11.9189 3.65709 12.097 3.61306 12.2748 3.62921C12.4527 3.64535 12.6199 3.72073 12.7498 3.84328C12.8797 3.96582 12.9647 4.12842 12.9912 4.30502C13.0177 4.48162 12.9841 4.662 12.8958 4.81724L7.58083 10.1322C7.50996 10.2125 7.42344 10.2775 7.32656 10.3232C7.22968 10.3689 7.12449 10.3944 7.01744 10.398Z",
      fill: "currentColor"
    })
  ])
], -1)
const _hoisted_92 = {
  key: 0,
  class: "card",
  style: {"z-index":"10","position":"absolute","top":"30px","left":"1px","min-width":"20rem","transform-origin":"center top","margin-top":"2px"}
}
const _hoisted_93 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_94 = { class: "w-4 pl-1 pr-0" }
const _hoisted_95 = {
  key: 0,
  class: "text-sm font-italic text-red-400"
}
const _hoisted_96 = { class: "grid mt-1 ml-0 mr-0" }
const _hoisted_97 = { class: "col-6 pt-1 pl-0 pr-1 pb-0 flex justify-content-center" }
const _hoisted_98 = { class: "col-6 pt-1 pl-0 pr-0 pb-0 flex justify-content-center" }
const _hoisted_99 = { class: "list-none pl-2 shadow-1 surface-card border-round-md" }
const _hoisted_100 = { class: "grid ml-0 mr-0" }
const _hoisted_101 = { class: "col-10 flex pr-8 pb-0 pt-0 align-items-center" }
const _hoisted_102 = { class: "w-8" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("span", { class: "w-1" }, " - ", -1)
const _hoisted_104 = { class: "w-3 flex justify-content-end" }
const _hoisted_105 = { class: "text-right" }
const _hoisted_106 = { class: "col-2 pl-1 pb-0 pt-0 flex justify-content-end" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2 mb-2 border-solid border-1 surface-border" }, null, -1)
const _hoisted_108 = { class: "flex justify-content-center" }
const _hoisted_109 = { class: "w-4 pt-0 pl-0 pr-1 pb-0 flex justify-content-center" }
const _hoisted_110 = { class: "w-4 pt-0 pl-0 pr-1 pb-0 flex justify-content-center" }
const _hoisted_111 = { class: "w-4 pt-0 pl-0 pr-0 pb-0 flex justify-content-center" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3 border-solid border-1 surface-border" }, null, -1)
const _hoisted_113 = { class: "pl-3" }
const _hoisted_114 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-clock" }, null, -1)
const _hoisted_115 = { class: "grid" }
const _hoisted_116 = { class: "grid w-full h-full" }
const _hoisted_117 = { class: "col-6 p-2" }
const _hoisted_118 = { class: "text-left font-bold" }
const _hoisted_119 = { class: "text-left mt-5" }
const _hoisted_120 = { class: "col-6 p-1 flex justify-content-center" }
const _hoisted_121 = { class: "w-full h-full flex justify-content-center align-items-center" }
const _hoisted_122 = ["src", "onLoad"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_PrimevueCheckbox = _resolveComponent("PrimevueCheckbox")!
  const _component_PrimevueSelect = _resolveComponent("PrimevueSelect")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _component_InputIcon = _resolveComponent("InputIcon")!
  const _component_IconField = _resolveComponent("IconField")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_PrimevueCard = _resolveComponent("PrimevueCard")!
  const _component_PrimevueTag = _resolveComponent("PrimevueTag")!
  const _component_PrimevueDialog = _resolveComponent("PrimevueDialog")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PrimevueCard, { class: "sm:w-12 md:w-10 lg:w-10 xl:w-6 mb-2" }, {
      title: _withCtx(() => [
        _createTextVNode("BALÍK")
      ]),
      subtitle: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/mod-stock/scan-item",
            class: "w-full"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PrimevueButton, {
                label: "Skenovať QR kód",
                severity: "success",
                icon: "pi pi-camera",
                text: "",
                raised: "",
                class: "uppercase w-full"
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_PrimevueButton, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.printLabel())),
            label: "Vytlač štítok",
            disabled: !(this.multiPack.id > 0),
            icon: "pi pi-print",
            severity: "success",
            text: "",
            raised: "",
            class: "w-full uppercase"
          }, null, 8, ["disabled"])
        ])
      ]),
      content: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => ($options.submitHandler && $options.submitHandler(...args)), ["prevent"])),
          name: "packageForm"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createVNode(_component_InputText, {
                      class: "w-full",
                      disabled: "",
                      modelValue: this.multiPack.code,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.multiPack.code) = $event)),
                      type: "text",
                      name: "multipackage-code",
                      id: "multipackage-code"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createVNode(_component_InputText, {
                      class: "w-full",
                      modelValue: this.multiPack.location,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((this.multiPack.location) = $event)),
                      type: "text",
                      name: "package-location",
                      id: "package-location"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createVNode(_component_PrimevueCheckbox, {
                          modelValue: this.imitation,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((this.imitation) = $event)),
                          inputId: "imitation",
                          name: "imitation",
                          binary: true,
                          onChange: _cache[4] || (_cache[4] = ($event: any) => ($options.setColors()))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createVNode(_component_PrimevueSelect, {
                      id: "package-color",
                      modelValue: this.selectedColor,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((this.selectedColor) = $event)),
                      options: this.colors,
                      optionLabel: "code",
                      placeholder: "Vyber farbu",
                      class: _normalizeClass(["w-full", `${$setup.v$.selectedColor.$error ? 'bg-red-200' : ''}`]),
                      invalid: $setup.v$.selectedColor.$error
                    }, {
                      value: _withCtx((slotProps) => [
                        (slotProps.value.id != 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _createElementVNode("div", {
                                class: "color-box mr-2",
                                style: _normalizeStyle({ backgroundColor: slotProps.value.colorHash })
                              }, null, 4),
                              _createElementVNode("div", null, _toDisplayString(slotProps.value.code), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(slotProps.placeholder), 1))
                      ]),
                      option: _withCtx((slotProps) => [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", {
                            class: "color-box mr-2",
                            style: _normalizeStyle({ backgroundColor: slotProps.option.colorHash })
                          }, null, 4),
                          _createElementVNode("div", null, _toDisplayString(slotProps.option.code), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "options", "class", "invalid"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.selectedColor.$errors, (error, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "text-sm font-italic text-red-400"
                      }, _toDisplayString(error.$message), 1))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createVNode(_component_InputNumber, {
                      inputClass: "w-full",
                      inputId: "multipack-numberOfPieces",
                      useGrouping: false,
                      disabled: "",
                      modelValue: this.multiPack.numberOfPieces,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((this.multiPack.numberOfPieces) = $event)),
                      name: "multipack-numberOfPieces",
                      id: "multipack-numberOfPieces"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createVNode(_component_InputNumber, {
                      inputId: "multipack-numberOfFreePieces",
                      useGrouping: false,
                      disabled: "",
                      modelValue: this.numberOfFreePieces,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((this.numberOfFreePieces) = $event)),
                      name: "multipack-numberOfFreePieces",
                      id: "multipack-numberOfFreePieces",
                      inputClass: "w-full bg-green-200"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createVNode(_component_InputNumber, {
                      inputClass: "w-full",
                      inputId: "multipack-numberOfReservedPieces",
                      useGrouping: false,
                      disabled: "",
                      modelValue: this.multiPack.numberOfReservedPieces,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((this.multiPack.numberOfReservedPieces) = $event)),
                      name: "multipack-numberOfReservedPieces",
                      id: "multipack-numberOfReservedPieces"
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_Fieldset, {
                legend: "Pridanie produktu do balíka",
                toggleable: "",
                collapsed: this.routeParams.packageId > 0,
                class: "multipack"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _hoisted_38,
                        _createVNode(_component_PrimevueSelect, {
                          id: "package-category",
                          modelValue: this.selectedCategory,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((this.selectedCategory) = $event)),
                          options: this.categories,
                          optionLabel: "name",
                          placeholder: "Vyber kategóriu",
                          class: _normalizeClass(["w-full", `${$setup.v$.selectedCategory.$error ? 'bg-red-200' : ''}`]),
                          invalid: $setup.v$.selectedCategory.$error,
                          onChange: _cache[10] || (_cache[10] = ($event: any) => ($options.selectCategory(this.selectedCategory.id)))
                        }, {
                          value: _withCtx((slotProps) => [
                            (slotProps.value.id != 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                  _createElementVNode("div", _hoisted_40, _toDisplayString(slotProps.value.name), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_41, [
                                  _createElementVNode("div", _hoisted_42, _toDisplayString(slotProps.placeholder), 1)
                                ]))
                          ]),
                          option: _withCtx((slotProps) => [
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("div", null, _toDisplayString(slotProps.option.name), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options", "class", "invalid"]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.selectedCategory.$errors, (error, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "text-sm font-italic text-red-400"
                          }, _toDisplayString(error.$message), 1))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _hoisted_46,
                        _createVNode(_component_InputNumber, {
                          inputId: "product-number",
                          useGrouping: false,
                          disabled: !(this.selectedCategory.name && this.selectedProduct.code),
                          modelValue: this.selectedProduct.numberOfProd,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((this.selectedProduct.numberOfProd) = $event)),
                          name: "product-number",
                          id: "product-number",
                          inputClass: `${$setup.v$.selectedProduct.numberOfProd.$error ? 'text-sm bg-red-200 w-full' : 'text-sm w-full'}`,
                          invalid: $setup.v$.selectedProduct.numberOfProd.$error
                        }, null, 8, ["disabled", "modelValue", "inputClass", "invalid"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _hoisted_50,
                        _createElementVNode("div", _hoisted_51, [
                          _createVNode(_component_PrimevueSelect, {
                            id: "package-product",
                            disabled: !this.selectedCategory.name,
                            modelValue: this.selectedProduct,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((this.selectedProduct) = $event)),
                            filter: "",
                            options: this.products,
                            optionLabel: "code",
                            placeholder: "Vyber produkt",
                            class: _normalizeClass(["w-full", `${$setup.v$.selectedProduct.code.$error ? 'bg-red-200' : ''}`]),
                            invalid: $setup.v$.selectedProduct.code.$error
                          }, {
                            value: _withCtx((slotProps) => [
                              (slotProps.value.id != 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                    _createElementVNode("div", _hoisted_53, _toDisplayString(slotProps.value.code) + " - " + _toDisplayString(slotProps.value.name.length > 22 ? slotProps.value.name.slice(0, 22) + '...' : slotProps.value.name), 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_54, [
                                    _createElementVNode("div", _hoisted_55, _toDisplayString(slotProps.placeholder), 1)
                                  ]))
                            ]),
                            option: _withCtx((slotProps) => [
                              _createElementVNode("div", _hoisted_56, [
                                _createElementVNode("div", null, _toDisplayString(slotProps.option.code) + " - " + _toDisplayString(slotProps.option.name), 1)
                              ])
                            ]),
                            _: 1
                          }, 8, ["disabled", "modelValue", "options", "class", "invalid"]),
                          _withDirectives(_createVNode(_component_PrimevueButton, {
                            type: "button",
                            class: "products",
                            icon: "pi pi-table",
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (this.visibleProducts = true)),
                            text: "",
                            severity: "primary",
                            size: "large"
                          }, null, 512), [
                            [
                              _directive_tooltip,
                              { value: 'Zobrazenie a výber produktov' },
                              void 0,
                              { top: true }
                            ]
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.selectedProduct.$errors, (error, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "text-sm font-italic text-red-400"
                          }, _toDisplayString(error.$message), 1))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, [
                        _hoisted_59,
                        _createVNode(_component_InputNumber, {
                          inputId: "package-length",
                          useGrouping: false,
                          disabled: !(this.selectedCategory.name && this.selectedProduct.code),
                          modelValue: this.selectedProduct.length,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((this.selectedProduct.length) = $event)),
                          name: "package-length",
                          id: "package-length",
                          inputClass: `${$setup.v$.selectedProduct.length.$error ? 'text-sm bg-red-200 w-full' : 'text-sm w-full'}`,
                          invalid: $setup.v$.selectedProduct.length.$error
                        }, null, 8, ["disabled", "modelValue", "inputClass", "invalid"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_60, [
                    (this.selectedProduct.image)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                          _createElementVNode("img", {
                            src: this.selectedProduct.image,
                            alt: "Preview Image",
                            class: "preview-image"
                          }, null, 8, _hoisted_62)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_63, _hoisted_65))
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    _createVNode(_component_PrimevueButton, {
                      onClick: _cache[15] || (_cache[15] = ($event: any) => ($options.addProduct())),
                      label: "Pridať produkt do balíka",
                      disabled: !(this.selectedProduct.id != 0 && this.selectedProduct.length > 0),
                      severity: "success",
                      text: "",
                      raised: "",
                      class: "w-full uppercase"
                    }, null, 8, ["disabled"])
                  ])
                ]),
                _: 1
              }, 8, ["collapsed"])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.packages, (pack, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "w-12 md:w-6 lg:w-6 p-1"
              }, [
                _createVNode(_component_Fieldset, {
                  legend: pack.product.code,
                  toggleable: "",
                  collapsed: "",
                  class: "multipack"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("div", _hoisted_69, [
                          _hoisted_70,
                          _createVNode(_component_InputText, {
                            id: "package-product",
                            disabled: "",
                            placeholder: pack.product.code +' * '+pack.product.name,
                            class: "text-sm w-full"
                          }, null, 8, ["placeholder"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_71, [
                        _createElementVNode("div", _hoisted_72, [
                          _hoisted_73,
                          _createVNode(_component_InputNumber, {
                            inputClass: "text-sm w-full",
                            inputId: "package-length",
                            useGrouping: false,
                            disabled: "",
                            modelValue: pack.length,
                            "onUpdate:modelValue": ($event: any) => ((pack.length) = $event),
                            name: "package-length",
                            id: "package-length"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("div", _hoisted_75, [
                        _createElementVNode("div", _hoisted_76, [
                          _createElementVNode("img", {
                            src: pack.product.image,
                            style: _normalizeStyle(`${pack.imageHeight >= pack.imageWidth ? 'height:170px;' : 'width:190px;'}`),
                            onLoad: ($event: any) => ($options.checkImageSize(index,$event)),
                            alt: "Preview Image",
                            class: ""
                          }, null, 44, _hoisted_77)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_78, [
                        _createElementVNode("div", _hoisted_79, [
                          _hoisted_80,
                          _createVNode(_component_InputNumber, {
                            inputId: "package-numberOfPieces",
                            useGrouping: false,
                            modelValue: pack.numberOfPieces,
                            "onUpdate:modelValue": ($event: any) => ((pack.numberOfPieces) = $event),
                            name: "package-numberOfPieces",
                            id: "package-numberOfPieces",
                            inputClass: `${pack.numberOfPiecesIsWrong ? 'bg-red-200 w-full' : 'w-full'}`,
                            invalid: pack.numberOfPiecesIsWrong
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "inputClass", "invalid"])
                        ]),
                        _createElementVNode("div", _hoisted_81, [
                          _hoisted_82,
                          _createVNode(_component_InputNumber, {
                            inputId: "package-numberOfFreePieces",
                            useGrouping: false,
                            disabled: "",
                            modelValue: pack.numberOfFreePieces,
                            "onUpdate:modelValue": ($event: any) => ((pack.numberOfFreePieces) = $event),
                            name: "package-numberOfFreePieces",
                            id: "package-numberOfFreePieces",
                            inputClass: "w-full bg-green-200"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_83, [
                          _hoisted_84,
                          _createVNode(_component_InputNumber, {
                            inputClass: "w-full",
                            inputId: "package-numberOfReservedPieces",
                            useGrouping: false,
                            disabled: "",
                            modelValue: pack.numberOfReservedPieces,
                            "onUpdate:modelValue": ($event: any) => ((pack.numberOfReservedPieces) = $event),
                            name: "package-numberOfReservedPieces",
                            id: "package-numberOfReservedPieces"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ])
                      ])
                    ]),
                    (pack.numberOfPiecesIsWrong)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_85, " Počet kusov je nesprávny "))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_86, [
                      _createElementVNode("div", _hoisted_87, [
                        _createElementVNode("div", _hoisted_88, [
                          _createVNode(_component_PrimevueButton, {
                            onClick: ($event: any) => ($options.initOrders(index)),
                            label: "test",
                            style: {"height":"2rem"},
                            class: "flex justify-content-between w-full",
                            outlined: "",
                            id: "item-order"
                          }, {
                            default: _withCtx(() => [
                              (pack.selectedOrder)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_89, _toDisplayString(pack.selectedOrder.orderCode), 1))
                                : _createCommentVNode("", true),
                              (!pack.selectedOrder)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_90, "Vyber objednávku"))
                                : _createCommentVNode("", true),
                              _hoisted_91
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          (pack.visibleSelect)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                                _createVNode(_component_IconField, { iconPosition: "left" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_InputIcon, null, {
                                      default: _withCtx(() => [
                                        _hoisted_93
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_InputText, {
                                      modelValue: $data.orderFilters['global'].value,
                                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($data.orderFilters['global'].value) = $event)),
                                      placeholder: "Vyhľadať",
                                      onInput: ($event: any) => ($options.onOrderFilter(index))
                                    }, null, 8, ["modelValue", "onInput"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_DataTable, {
                                  lazy: "",
                                  paginator: "",
                                  rows: pack.selectParams.rows,
                                  onPage: ($event: any) => ($options.onOrderPage(index,$event)),
                                  first: pack.selectParams.first,
                                  loading: $data.selectLoading,
                                  totalRecords: pack.selectParams.totalRecords,
                                  dataKey: "id",
                                  value: pack.orderOptions,
                                  scrollHeight: `${200}px`,
                                  virtualScrollerOptions: { itemSize: 40 },
                                  stripedRows: "",
                                  "row-hover": "",
                                  scrollable: "",
                                  selection: pack.selectedOrder,
                                  "onUpdate:selection": ($event: any) => ((pack.selectedOrder) = $event),
                                  selectionMode: "single",
                                  metaKeySelection: false,
                                  onRowSelect: ($event: any) => ($options.selectOrder(index)),
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Column, {
                                      header: "ID",
                                      field: "orderCode",
                                      style: {"width":"5%"}
                                    }),
                                    _createVNode(_component_Column, {
                                      header: "Meno",
                                      field: "customer.lastName",
                                      style: {"width":"50%"}
                                    }),
                                    _createVNode(_component_Column, {
                                      header: "Obec",
                                      field: "customer.city",
                                      style: {"width":"45%"}
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["rows", "onPage", "first", "loading", "totalRecords", "value", "selection", "onUpdate:selection", "onRowSelect"])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_94, [
                          _createVNode(_component_InputNumber, {
                            inputId: "numberOfReservedPieces",
                            useGrouping: false,
                            disabled: !(pack.selectedOrder),
                            modelValue: pack.numberOfReservedItems,
                            "onUpdate:modelValue": ($event: any) => ((pack.numberOfReservedItems) = $event),
                            name: "numberOfReservedPieces",
                            id: "numberOfReservedPieces",
                            inputClass: `${pack.numberOfReservedItemIsWrong  ? 'bg-red-200 w-full' : 'w-full'}`,
                            invalid: pack.numberOfReservedItemIsWrong,
                            placeholder: "Rezer. kusy"
                          }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "inputClass", "invalid"])
                        ])
                      ]),
                      (pack.numberOfReservedItemIsWrong)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_95, " Chybný počet rezer. kusov "))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_96, [
                        _createElementVNode("div", _hoisted_97, [
                          _createVNode(_component_PrimevueButton, {
                            onClick: ($event: any) => ($options.saveOrReservePack(index)),
                            label: "Uložiť/Rezer.",
                            severity: "success",
                            text: "",
                            raised: "",
                            class: "w-full uppercase"
                          }, null, 8, ["onClick"])
                        ]),
                        _createElementVNode("div", _hoisted_98, [
                          _createVNode(_component_PrimevueButton, {
                            onClick: ($event: any) => ($options.confirmDeletePack(pack.id)),
                            label: "Odstrániť",
                            disabled: pack.numberOfReservedPieces > 0,
                            severity: "danger",
                            text: "",
                            raised: "",
                            class: "w-full uppercase"
                          }, null, 8, ["onClick", "disabled"])
                        ])
                      ])
                    ]),
                    _createElementVNode("ul", _hoisted_99, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pack.reservedItems, (r) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: r.id
                        }, [
                          _createElementVNode("div", _hoisted_100, [
                            _createElementVNode("div", _hoisted_101, [
                              _createElementVNode("span", _hoisted_102, _toDisplayString(r.order.orderCode), 1),
                              _hoisted_103,
                              _createElementVNode("div", _hoisted_104, [
                                _createElementVNode("div", _hoisted_105, _toDisplayString(r.numberOfItems), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_106, [
                              _withDirectives(_createVNode(_component_PrimevueButton, {
                                type: "button",
                                icon: "pi pi-times",
                                onClick: ($event: any) => ($options.confirmDelete(r.id)),
                                text: "",
                                severity: "danger",
                                size: "small"
                              }, null, 8, ["onClick"]), [
                                [
                                  _directive_tooltip,
                                  { value: 'Zrušenie rezervácie' },
                                  void 0,
                                  { top: true }
                                ]
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 2
                }, 1032, ["legend"])
              ]))
            }), 128))
          ]),
          _hoisted_107,
          _createElementVNode("div", _hoisted_108, [
            _createElementVNode("div", _hoisted_109, [
              _createVNode(_component_PrimevueButton, {
                type: "submit",
                label: "Uložiť balík",
                severity: "success",
                text: "",
                raised: "",
                class: "w-full uppercase"
              })
            ]),
            _createElementVNode("div", _hoisted_110, [
              _withDirectives(_createVNode(_component_PrimevueButton, {
                onClick: _cache[17] || (_cache[17] = ($event: any) => ($options.confirmMultiPackDelete(this.multiPack.id))),
                label: "Odstrániť balík",
                severity: "danger",
                disabled: this.routeParams.packageId == 0,
                text: "",
                raised: "",
                class: "w-full uppercase"
              }, null, 8, ["disabled"]), [
                [
                  _directive_tooltip,
                  { value: `${this.multiPack.numberOfPieces > 0 ? 'Odstrániť balík je možné až po odstránení všetkých produktov' : ''}` },
                  void 0,
                  { top: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_111, [
              _createVNode(_component_PrimevueButton, {
                onClick: _cache[18] || (_cache[18] = ($event: any) => ($options.closeForm())),
                label: "Zavrieť",
                text: "",
                raised: "",
                class: "w-full uppercase"
              })
            ])
          ])
        ], 32)
      ]),
      _: 1
    }),
    _createVNode(_component_PrimevueCard, { class: "sm:w-12 md:w-10 lg:w-10 xl:w-6" }, {
      title: _withCtx(() => [
        _createTextVNode("Pohyby s balíkom")
      ]),
      subtitle: _withCtx(() => [
        _hoisted_112
      ]),
      content: _withCtx(() => [
        _createElementVNode("ul", _hoisted_113, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.stockMovements, (history) => {
            return (_openBlock(), _createElementBlock("li", {
              key: history.id
            }, [
              _hoisted_114,
              _createTextVNode(" " + _toDisplayString($options.Utils.formatToSlovak(history.createdAt)) + " ", 1),
              _createVNode(_component_PrimevueTag, {
                class: "text-sm",
                value: history.action,
                style: _normalizeStyle({ backgroundColor: history.color })
              }, null, 8, ["value", "style"]),
              _createTextVNode(" - " + _toDisplayString(history.user.firstName) + " " + _toDisplayString(history.user.lastName), 1)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_PrimevueDialog, {
      visible: this.visibleProducts,
      "onUpdate:visible": _cache[21] || (_cache[21] = ($event: any) => ((this.visibleProducts) = $event)),
      header: "Produkty",
      style: { width: '60rem' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_115, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.products, (prod, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "p-1 sm:col-12 md:col-4 lg:col-4 xl:col-4"
            }, [
              _createVNode(_component_PrimevueButton, {
                outlined: "",
                class: "p-1",
                onClick: ($event: any) => ($options.setSelectProduct(prod) ),
                onMouseover: ($event: any) => (this.hoverIndex = index),
                onMouseleave: _cache[20] || (_cache[20] = ($event: any) => (this.hoverIndex = null)),
                style: _normalizeStyle($options.buttonStyle(index))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_116, [
                    _createElementVNode("div", _hoisted_117, [
                      _createElementVNode("div", _hoisted_118, _toDisplayString(prod.code), 1),
                      _createElementVNode("div", _hoisted_119, _toDisplayString(prod.name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_120, [
                      _createElementVNode("div", _hoisted_121, [
                        _createElementVNode("img", {
                          src: prod.image,
                          style: _normalizeStyle(`${prod.imageHeight >= prod.imageWidth ? 'height:168px;' : 'width:140px;'}`),
                          onLoad: ($event: any) => ($options.checkImageSizeProd(index,$event)),
                          alt: "Preview Image",
                          class: ""
                        }, null, 44, _hoisted_122)
                      ])
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["onClick", "onMouseover", "style"])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_ConfirmDialog)
  ]))
}